'use client';

import React from 'react';
import { Card } from 'src/components/PulseUI';
import { useWidgetConfig } from 'src/context/providers/WidgetConfigProvider';
import MonthlyAvgBadge from 'src/components/Profiles/shared/widgets/shared/MonthlyAvgBadge';
import TargetBadge from 'src/components/Profiles/shared/widgets/shared/TargetBadge';
import WidgetHeader from 'src/components/Profiles/shared/widgets/WidgetHeader';
import VolumeDifferenceContent from './VolumeDifferenceContent';

const CompactVolumeDifference: React.FC = () => {
  const widgetConfig = useWidgetConfig();
  const widget = widgetConfig?.widget ?? null;

  const benchmark = widget?.benchmark ?? null;
  const displayMode = widget?.display_mode;

  const trailing = (
    <div className="flex items-center gap-2">
      {displayMode === 'monthly_average' && <MonthlyAvgBadge />}
      {benchmark !== null && (
        <TargetBadge
          target={benchmark}
          testId="compact-volume-difference-target-badge"
        />
      )}
    </div>
  );

  return (
    <Card
      className="p-5 flex flex-col gap-3 bg-white h-full"
      data-testid="compact-volume-difference"
      role="region"
      aria-label={widget?.label ?? 'Volume Difference'}
    >
      <WidgetHeader
        fallbackTitle="Volume Difference"
        showDateRange={false}
        trailing={trailing}
      />
      <div className="flex-1 min-h-0 overflow-y-auto">
        <VolumeDifferenceContent />
      </div>
    </Card>
  );
};

export default CompactVolumeDifference;
